/**
 * Get the current video player time
 */
export function createCurrentTime (startPosition, player) {
  try {
    const duration = player.duration()
    if (startPosition < 60) {
      return 0
    }
    if (duration > 0 && startPosition > duration - 60) {
      return 0
    }
    return startPosition - 5
  } catch (e) {
    return 0
  }
}

export function setPosition (position, player) {
  try {
    player.currentTime(position)
  } catch (e) {
    // Do nothing
  }
}

export function getCurrentPosition (player) {
  try {
    return Math.floor(player.currentTime())
  } catch (e) {
    return 0
  }
}
